import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const AdminEventPage = (props) => {

    const [allEvent, setAllEvent] = useState([]);


    function getActivite(e) {       // liste des activités pour l'agenda de la semaine (validé)

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/allActivite`,

        })
            .then((res) => {
                setAllEvent(res.data)
            })
            .catch((err) => {
                console.log(err);
            })
    }

    useEffect(() => {
        getActivite()
    }, []);

    return (
        <div className='adminAllEvent'>
            <Link className='exitButton' to="/profil"><FontAwesomeIcon icon={faArrowLeft} /></Link>

            <div className='adminAllEvent__container'>
                <h1>Choisissez l'event a administrer:</h1>

                <div className='weeklyEventCont'>
                    {allEvent.map((event) => (
                        <Link key={event.id} to={`/adminOneEvent/${event.id}`} className="event-link">
                            <div className='adminEventCard' id={event.id} >
                                <img src={event.randomImage} alt='event aléatoire' />
                                <div className='adminEventCardInfo'>
                                    <span>
                                        <img src={event.logo} alt='event aléatoire' />
                                        <p>{event.jour} {event.date} </p>
                                        <p className='changeTitleColor'>{event.titre} </p>
                                    </span>

                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

            </div>


        </div>
    );
};

export default AdminEventPage;